import { render, staticRenderFns } from "./posFlagModal.vue?vue&type=template&id=67258530&"
import script from "./posFlagModal.vue?vue&type=script&lang=js&"
export * from "./posFlagModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports